import { render } from "./user_info_top.vue?vue&type=template&id=09142d0c"
import script from "./user_info_top.vue?vue&type=script&lang=js"
export * from "./user_info_top.vue?vue&type=script&lang=js"

import exportComponent from "/home/king/git/miniapp/northland-bio-miniapp-webclient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__